import { Injectable, inject } from '@angular/core';

import { IssueService } from '../issue.service';
import { SocketService } from '../socket.service';
import { TenantService } from '../tenant.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface IssueTypesUpdatedSocketEvent {
    eventDtoType: 'IssueTypesUpdated';
}

@Injectable({ providedIn: 'root' })
export class IssueTypesUpdatedSocketEventHandler extends BaseSocketEventHandler<IssueTypesUpdatedSocketEvent> {
    private tenantService = inject(TenantService);
    private issueService = inject(IssueService);

    protected eventDtoType(): string {
        return 'IssueTypesUpdated';
    }

    protected handleEvent = async (_: IssueTypesUpdatedSocketEvent): Promise<void> => {
        await this.tenantService.refreshConfig();
        await this.issueService.refreshIssueTypes();
    };
}
